// extracted by mini-css-extract-plugin
export default {"skill":"Skills_skill__G9NEA","logo":"Skills_logo__EOpjx"};